<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  detected: { type: String, default: '' },
  current: { type: String, default: '' },
});
defineEmits(['apply']);

const { t } = useI18n();

// Already in the field: confirm where it came from instead of offering it.
const isApplied = computed(
  () => !!props.detected && props.detected === props.current
);
</script>

<template>
  <div v-if="detected" class="flex mt-1">
    <span
      v-if="isApplied"
      class="flex items-center gap-1.5 px-2 py-1 text-xs rounded-md text-n-teal-11 bg-n-teal-2 border border-n-teal-4"
    >
      <span class="i-lucide-sparkles size-3 shrink-0" />
      {{ t('SALES_FUNNEL.SEND_TO_FUNNEL.TAKEN_FROM_CHAT') }}
    </span>
    <button
      v-else
      type="button"
      class="flex items-center gap-1.5 px-2 py-1 max-w-full text-xs rounded-md text-n-amber-11 bg-n-amber-2 border border-n-amber-4 hover:bg-n-amber-3 transition-colors"
      :title="t('SALES_FUNNEL.SEND_TO_FUNNEL.USE_DETECTED')"
      @click="$emit('apply')"
    >
      <span class="i-lucide-sparkles size-3 shrink-0" />
      <span class="shrink-0">
        {{ t('SALES_FUNNEL.SEND_TO_FUNNEL.DETECTED') }}
      </span>
      <span class="font-medium truncate">{{ detected }}</span>
    </button>
  </div>
</template>
